module.exports = __webpack_public_path__ + "img/f.5f55b47c.jpg";